module.exports = __webpack_public_path__ + "img/logo-nutas.cd4d3eee.png";